import { UnavailabilityError } from 'expo-errors';

export function withNativeAd() {
  throw new UnavailabilityError('FacebookAds', 'withNativeAd');
}
export function AdMediaView() {
  throw new UnavailabilityError('FacebookAds', 'AdMediaView');
}
export function AdIconView() {
  throw new UnavailabilityError('FacebookAds', 'AdIconView');
}
export function AdTriggerView() {
  throw new UnavailabilityError('FacebookAds', 'AdTriggerView');
}
export function AdSettings() {
  throw new UnavailabilityError('FacebookAds', 'AdSettings');
}
export function NativeAdsManager() {
  throw new UnavailabilityError('FacebookAds', 'NativeAdsManager');
}
export function InterstitialAdManager() {
  throw new UnavailabilityError('FacebookAds', 'InterstitialAdManager');
}
export function BannerAd() {
  throw new UnavailabilityError('FacebookAds', 'BannerAd');
}
